export default "__VITE_ASSET__8167e534__"